import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { IMAGES, LOGO } from "@/lib/images";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back."); navigate("/admin"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-noir">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={IMAGES.yacht} alt="" className="w-full h-full object-cover brightness-[0.5]" />
        <div className="absolute inset-0 bg-gradient-to-t from-noir to-transparent" />
        <div className="absolute bottom-12 left-12">
          <p className="font-serif text-4xl font-light leading-tight">Inforno Travel<br /><span className="italic text-gold">Concierge Suite</span></p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-sm">
          <Link to="/"><img src={LOGO} alt="Inforno Travel" className="h-14 w-auto" /></Link>
          <p className="font-body text-[11px] uppercase tracking-[0.4em] text-gold mt-8 mb-3">Administrator</p>
          <h1 className="font-serif text-4xl font-light mb-10">Sign in</h1>
          <form data-testid="login-form" onSubmit={submit} className="space-y-7">
            <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/15 py-3 text-ink placeholder-white/30 focus:border-gold focus:outline-none transition-colors" />
            <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/15 py-3 text-ink placeholder-white/30 focus:border-gold focus:outline-none transition-colors" />
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full border border-gold text-gold py-4 font-body text-xs uppercase tracking-[0.25em] hover:bg-gold hover:text-black transition-colors duration-300 disabled:opacity-50">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          <Link to="/" className="block mt-8 text-white/40 text-xs uppercase tracking-[0.2em] hover:text-gold transition-colors">← Back to site</Link>
        </div>
      </div>
    </div>
  );
}
